export default __webpack_public_path__ + "static/bg-diagonal-f0c4168a78c7e48d8427502de5a79faf.webp";